export default "<div class=\"row\">\n  <nb-card>\n    <nb-card-body>Hello from ngx-admin sandbox project.</nb-card-body>\n  </nb-card>\n</div>\n";